import { render, staticRenderFns } from "./IntersectionObserver.vue?vue&type=template&id=2a3623aa&"
import script from "./IntersectionObserver.vue?vue&type=script&lang=ts&"
export * from "./IntersectionObserver.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports